import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FiInfo, FiStar } from 'react-icons/fi';
import { cn } from '@/lib/utils';
import bannerEvento from '@/assets/images/placeholders/banner-evento.png';
import liveScreenIcon from '@/assets/images/icons/live-screen.png';
import challengeIcon from '@/assets/images/icons/desafio-da-semana.png';
import provasIcon from '@/assets/images/icons/provas.png';
import projetosIcon from '@/assets/images/icons/projetos.png';

function resolveDateTime(item) {
  const startDateTime = item['initial-time'] ? moment(`${item['initial-date']} ${item['initial-time']}`, 'YYYY-MM-DD HH:mm') : moment(item['initial-date']);

  const endDateTime = item['end-time'] ? moment(`${item['initial-date']} ${item['end-time']}`, 'YYYY-MM-DD HH:mm') : moment(item['end-date'] || item['initial-date']);

  return { startDateTime, endDateTime };
}

const ALERT_TYPE_ICON = {
  challenge: challengeIcon,
  exam: provasIcon,
  project: projetosIcon
};

function PlayfulCalendarAlertCard({ event, isActive }) {
  const navigate = useNavigate();
  const isClickable = !!event['access-url'];
  const iconSrc = ALERT_TYPE_ICON[event['alert-type']];

  return (
    <div
      className={cn('relative flex items-center gap-3 rounded-2xl bg-mission-light p-3 transition-shadow duration-150', isClickable && 'cursor-pointer hover:shadow-card-hover', isActive && 'ring-2 ring-primary')}
      onClick={() => isClickable && navigate(event['access-url'])}
    >
      <div className="flex h-[52px] w-[52px] shrink-0 items-center justify-center overflow-hidden rounded-xl">
        {iconSrc ? (
          <img
            src={iconSrc}
            alt=""
            className="h-full w-full object-contain"
          />
        ) : (
          <span
            className="text-xl"
            style={{ color: 'var(--color-mission)' }}
          >
            {event['alert-type'] === 'survey' ? <FiStar /> : <FiInfo />}
          </span>
        )}
      </div>

      <div className="min-w-0 flex-grow">
        <h3 className="m-0 break-words text-sm font-extrabold text-[var(--color-mission-text)]">{event.name}</h3>
        <p className="m-0 mt-0.5 break-words text-xs text-neutral-dark">{event.description}</p>
      </div>
    </div>
  );
}

function PlayfulCalendarEventCard({ event, isActive }) {
  const navigate = useNavigate();

  if (event.type === 'alert') {
    return (
      <PlayfulCalendarAlertCard
        event={event}
        isActive={isActive}
      />
    );
  }

  const isLiveClass = event.type === 'live-classroom';
  const { startDateTime, endDateTime } = resolveDateTime(event);
  const isLive = isLiveClass && moment().isBetween(startDateTime, endDateTime);
  const isClickable = !isLiveClass || isLive;
  const timeLabel = isLiveClass ? `${startDateTime.format('HH:mm')} - ${endDateTime.format('HH:mm')}` : `${event['initial-time']} - ${event['end-time']}`;

  const handleClick = () => {
    if (isLiveClass) {
      if (isLive) navigate(`/aulas-ao-vivo/${event.id}`);
    } else {
      navigate(`/evento/${event.id}`);
    }
  };

  return (
    <div
      className={cn('relative flex items-center gap-3 rounded-2xl bg-mission-light p-3 transition-shadow duration-150', isClickable && 'cursor-pointer hover:shadow-card-hover', isActive && 'ring-2 ring-primary')}
      onClick={handleClick}
    >
      {isLive && <span className="absolute -right-1.5 -top-2 rounded-[4px] bg-[#FF5630] px-1.5 pt-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white shadow-sm">Ao vivo</span>}

      <div className="flex h-[52px] w-[52px] shrink-0 items-center justify-center overflow-hidden rounded-xl">
        {isLiveClass ? (
          <img
            src={liveScreenIcon}
            alt="Aula ao vivo"
            className="h-full w-full object-contain"
          />
        ) : (
          <img
            src={event.image?.url || bannerEvento}
            alt="banner evento"
            className="h-full w-full object-cover"
          />
        )}
      </div>

      <div className="min-w-0 flex-grow">
        <h3 className="m-0 text-sm font-extrabold text-[var(--color-mission-text)]">{timeLabel}</h3>
        <p className="m-0 mt-0.5 truncate text-xs text-neutral-dark">{event.title}</p>
      </div>
    </div>
  );
}

export { PlayfulCalendarEventCard };
